
/* tslint:disable:quotemark */
import { defineMessages } from "react-intl";

const MESSAGES = defineMessages({
  checkboxPositionsNoSpace: {
    id: "checkboxPositions.noSpace",
    defaultMessage: "Not enough space available",
  },
  checkboxPositionsTissueConflict: {
    id: "checkboxPositions.tissueConflict",
    defaultMessage: "Waste rail has changed",
  }
});

export default MESSAGES;